export const headerMenuItems = [
  {
    title: "Home",
    link: "/"
  },
  {
    title: "Movies",
    link: "/movies"
  },
  {
    title: "Search",
    link: "/search"
  }
]
export const footerMenuItems = [
  {
    title: "Home",
    link: "/"
  },
  {
    title: "Movies",
    link: "/movies"
  },
  {
    title: "Search",
    link: "/search"
  }
]